import ".././styles/Hero.css"
import Hero from ".././components/Hero.js"
import AboutPreview from ".././components/AboutPreview.js"
import NewsAnnouncementsPreview from "../components/NewsAnnouncementsPreview.js";
import FeaturedEvents from "../components/FeaturedEvents.js";
import BoardmembersPreview from "../components/BoardmembersPreview.js";
import GalleryPreview from "../components/GalleryPreview.js";

import infoIcon from ".././assets/info-icon.png"
import Banner from "../components/NotificationBanner";

function Home() {
    return (
        <>
            <Hero id="top"/>
            <AboutPreview />
            <NewsAnnouncementsPreview />
            <FeaturedEvents />
            <BoardmembersPreview />
            {/* <Banner
                image={infoIcon} 
                title="Note: "
                description="We have three spots available for new members of the governing board to join."
                buttonLink="/memberships#top"
                buttonName="Apply"
            /> */}
            <GalleryPreview />
        </>
    );
}

export default Home;